import {resources} from "../../../../../../core/models/resource/resources";

export const productPackageResourceType = resources['product-packages'];
export const productPackageFilesResourceType = resources['product-package-files'];

export const productPackagesTitleModal: Record<string, string> = {
  noPackageModalDto: 'Товар без упаковки',
  singleItemPackageModalDto: 'Товар 1шт. в упаковке для продажи',
  transportBoxModalDto: 'Товар в транспортировочном коробе',
  palletModalDto: 'Товар на паллете',
  truck33PalletsModalDto: 'Товар в фуре (33 паллета)',
  gazelle6PalletsModalDto: 'Товар в 6 паллетнике (газель)',
  gazelle10PalletsModalDto: 'Товар в 10 паллетнике (газель)'
};

export const productPackagesPackageType: Record<string, string> = {
  noPackageModalDto: 'NO_PACKAGE',
  singleItemPackageModalDto: 'SINGLE_ITEM_PACKAGE',
  transportBoxModalDto: 'TRANSPORT_BOX',
  palletModalDto: 'PALLET',
  truck33PalletsModalDto: 'TRUCK_33_PALLETS',
  gazelle6PalletsModalDto: 'GAZELLE_6_PALLETS',
  gazelle10PalletsModalDto: 'GAZELLE_10_PALLETS'
};
